import { useI18n } from '../../i18n';

const Footer = () => {
  const { t } = useI18n();
  const currentYear = new Date().getFullYear();

  return (
    <>
      {/* 🎓 마스터 1기 모집 배너 — 푸터 바로 위 인라인 (/wiabook/ 동일 방식) */}
      <style>{`
        @keyframes wiaMasterBannerPulse { 0%,100%{opacity:1} 50%{opacity:0.85} }
        @keyframes wiaMasterBannerShimmer { 0%{background-position:-200% center} 100%{background-position:200% center} }
        .wia-master-banner {
          display:block; text-decoration:none; text-align:center;
          padding:18px 24px; font-size:17px; font-weight:800; letter-spacing:0.5px; color:#fff;
          background:linear-gradient(90deg,rgba(139,92,246,0.22) 0%,rgba(236,72,153,0.28) 35%,rgba(251,191,36,0.30) 50%,rgba(236,72,153,0.28) 65%,rgba(59,130,246,0.22) 100%);
          background-size:200% 100%;
          animation:wiaMasterBannerPulse 2.2s ease-in-out infinite, wiaMasterBannerShimmer 5s linear infinite;
          border-bottom:1px solid rgba(251,191,36,0.35);
          position:relative; overflow:hidden;
          transition:transform 0.2s ease, background 0.2s ease, text-shadow 0.2s ease;
          text-shadow:0 0 12px rgba(251,191,36,0.65),0 0 24px rgba(236,72,153,0.45);
        }
        .wia-master-banner:hover {
          transform:scale(1.01);
          background:linear-gradient(90deg,rgba(139,92,246,0.75) 0%,rgba(236,72,153,0.82) 35%,rgba(251,191,36,0.85) 50%,rgba(236,72,153,0.82) 65%,rgba(59,130,246,0.75) 100%);
          text-shadow:0 0 18px rgba(255,255,255,0.9),0 0 30px rgba(251,191,36,0.9),0 0 40px rgba(236,72,153,0.7);
        }
        .wia-master-banner .wia-sep { margin:0 14px; opacity:0.55; font-weight:400; }
        .wia-master-banner .wia-badge {
          display:inline-block; margin-left:12px; padding:3px 10px; font-size:11.5px; font-weight:800; color:#fff;
          background:linear-gradient(135deg,#dc2626,#f59e0b); border-radius:999px;
          vertical-align:middle; letter-spacing:0.6px; box-shadow:0 0 10px rgba(239,68,68,0.6);
        }
        @media(max-width:640px){
          .wia-master-banner{font-size:14px;padding:14px 16px;letter-spacing:0.2px;}
          .wia-master-banner .wia-sep{margin:0 8px;}
          .wia-master-banner .wia-badge{margin-left:8px;padding:2px 8px;font-size:10.5px;}
        }
      `}</style>
      <a className="wia-master-banner"
         href="https://wiabook.com/scribes-apply/"
         target="_blank" rel="noopener"
         title="WIA 인생기록 마스터 1기 모집 · 5/17 개강 · 지원하기">
        <span>🎓 WIA 인생기록 마스터 1기 모집</span>
        <span className="wia-sep">·</span>
        <span>5/17 개강</span>
        <span className="wia-sep">·</span>
        <span>지원하기 →</span>
        <span className="wia-badge">NEW</span>
      </a>

      <footer className="bg-gradient-to-b from-[#0a0a1a] via-[#1a0a2e] to-[#0a1628] relative overflow-hidden">
        {/* 그리드 패턴 오버레이 */}
        <div
          className="absolute inset-0 pointer-events-none"
          style={{
            backgroundImage: 'linear-gradient(rgba(138, 43, 226, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(138, 43, 226, 0.1) 1px, transparent 1px)',
            backgroundSize: '50px 50px'
          }}
        />

        {/* 네온 글로우 라인 상단 */}
        <div
          className="h-[3px]"
          style={{
            background: 'linear-gradient(90deg, #ff00ff, #00ffff, #ff00ff)',
            boxShadow: '0 0 20px #ff00ff, 0 0 40px #00ffff'
          }}
        />

        {/* 메인 콘텐츠 */}
        <div className="relative z-10 px-10 py-12 max-w-[1400px] mx-auto">
          <div className="flex flex-wrap gap-10 mb-8">

            {/* 왼쪽: 로고 + 소개 + 회사정보 */}
            <div className="flex-1 min-w-[300px] max-w-[480px]">
              {/* 로고 + Follow Us 같은 줄 */}
              <div className="flex items-center justify-between mb-5">
                <a href="https://wiabook.com/" target="_blank" rel="noopener noreferrer" className="inline-block">
                  <img
                    id="footer-logo-rotate"
                    src="https://wiabook.com/assets/img/logos/16.png"
                    alt="WIA Book"
                    className="max-w-[200px] h-auto"
                    style={{ transition: 'opacity 0.6s ease' }}
                  />
                </a>
                {/* Follow Us + SNS */}
                <div className="flex flex-col items-end gap-2">
                  <span className="text-[#ff00ff] text-[12px] font-semibold" style={{ textShadow: '0 0 10px rgba(255, 0, 255, 0.5)' }}>
                    {t('footer.followUs')}
                  </span>
                  <div className="flex gap-3 items-center">
                    <a href="https://www.facebook.com/SmileStory.co.kr" target="_blank" rel="noopener noreferrer"
                       title="Facebook" className="hover:scale-110 transition-transform"
                       style={{ filter: 'drop-shadow(0 0 8px rgba(24, 119, 242, 0.6))' }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="#1877F2">
                        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
                      </svg>
                    </a>
                    <a href="https://www.instagram.com/wia.family" target="_blank" rel="noopener noreferrer"
                       title="Instagram" className="hover:scale-110 transition-transform"
                       style={{ filter: 'drop-shadow(0 0 8px rgba(228, 64, 95, 0.6))' }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="#E4405F">
                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
                      </svg>
                    </a>
                    <a href="https://www.youtube.com/@yeonsamheum" target="_blank" rel="noopener noreferrer"
                       title="YouTube" className="hover:scale-110 transition-transform"
                       style={{ filter: 'drop-shadow(0 0 8px rgba(255, 0, 0, 0.6))' }}>
                      <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="#FF0000">
                        <path d="M23.498 6.186a3.016 3.016 0 0 0-2.122-2.136C19.505 3.545 12 3.545 12 3.545s-7.505 0-9.377.505A3.017 3.017 0 0 0 .502 6.186C0 8.07 0 12 0 12s0 3.93.502 5.814a3.016 3.016 0 0 0 2.122 2.136c1.871.505 9.376.505 9.376.505s7.505 0 9.377-.505a3.015 3.015 0 0 0 2.122-2.136C24 15.93 24 12 24 12s0-3.93-.502-5.814zM9.545 15.568V8.432L15.818 12l-6.273 3.568z"/>
                      </svg>
                    </a>
                  </div>
                </div>
              </div>

              <p className="text-[#00ffff] text-[15px] font-semibold mb-4 leading-relaxed"
                 style={{ textShadow: '0 0 10px rgba(0, 255, 255, 0.5)' }}>
                {t('footer.catchphrase')}
              </p>
              <p className="text-[#a0a0c0] text-[13px] leading-relaxed mb-6">
                {t('footer.description')}
              </p>

              {/* 회사 정보 */}
              <div className="text-[12px] text-[#888] leading-relaxed">
                <p>
                  <strong className="text-[#c0c0e0]">{t('footer.publisher')}</strong> {t('footer.publisherName')} |{' '}
                  <strong className="text-[#c0c0e0]">{t('footer.corp')}</strong> {t('footer.corpName')} |{' '}
                  <strong className="text-[#c0c0e0]">{t('footer.ceo')}</strong> {t('footer.ceoName')}
                </p>
                <p>
                  <strong className="text-[#c0c0e0]">{t('footer.pubNo')}</strong> {t('footer.pubNoValue')} |{' '}
                  <strong className="text-[#c0c0e0]">{t('footer.bizNo')}</strong> {t('footer.bizNoValue')}
                </p>
                <p>
                  <strong className="text-[#c0c0e0]">{t('footer.hq')}</strong> {t('footer.address')}
                </p>
                <p>
                  <strong className="text-[#c0c0e0]">{t('footer.phone')}</strong> ☎ +82-1599-1045 |{' '}
                  <strong className="text-[#c0c0e0]">{t('footer.email')}</strong>{' '}
                  <a href="mailto:global@thekoreantoday.com" className="text-[#00ffff]"
                     style={{ textShadow: '0 0 5px rgba(0, 255, 255, 0.3)' }}>
                    global@thekoreantoday.com
                  </a>
                </p>
              </div>
            </div>

            {/* 오른쪽: 링크들 - 4열 7행 그리드 (가이드 최상단) */}
            <div className="flex-1 min-w-[300px] flex flex-col gap-5">

              {/* 🌟 0행: 사용자 가이드 + 공지 (골드, 신규 방문자 최우선 노출) */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-3 pb-4 border-b border-[#fbbf2459]">
                <a href="https://wiabook.com/guide/index.html" target="_blank" rel="noopener noreferrer"
                   className="text-[#fbbf24] text-[14px] hover:translate-y-[-2px] transition-all"
                   style={{ textShadow: '0 0 8px rgba(251, 191, 36, 0.5)' }}>
                  {t('footer.userGuide')}
                </a>
                <a href="https://wiabook.com/guide/reader.html" target="_blank" rel="noopener noreferrer"
                   className="text-[#fbbf24] text-[14px] hover:translate-y-[-2px] transition-all"
                   style={{ textShadow: '0 0 8px rgba(251, 191, 36, 0.5)' }}>
                  {t('footer.readerGuide')}
                </a>
                <a href="https://wiabook.com/guide/author.html" target="_blank" rel="noopener noreferrer"
                   className="text-[#fbbf24] text-[14px] hover:translate-y-[-2px] transition-all"
                   style={{ textShadow: '0 0 8px rgba(251, 191, 36, 0.5)' }}>
                  {t('footer.authorGuide')}
                </a>
                <a href="https://wiabook.com/category/notice/" target="_blank" rel="noopener noreferrer"
                   className="text-[#fbbf24] text-[14px] hover:translate-y-[-2px] transition-all"
                   style={{ textShadow: '0 0 8px rgba(251, 191, 36, 0.5)' }}>
                  {t('footer.notice')}
                </a>
              </div>

              {/* 1행: WIABook/Pubscript (마젠타) — 표준 */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-3">
                <a href="https://wiabook.com/wiabook" target="_blank" rel="noopener noreferrer"
                   className="text-[#ff00ff] text-[14px] hover:translate-y-[-2px] transition-all"
                   style={{ textShadow: '0 0 8px rgba(255, 0, 255, 0.5)' }}>
                  {t('footer.wiabook')}
                </a>
                <a href="https://wiabook.com/wiabook-api" target="_blank" rel="noopener noreferrer"
                   className="text-[#ff00ff] text-[14px] hover:translate-y-[-2px] transition-all"
                   style={{ textShadow: '0 0 8px rgba(255, 0, 255, 0.5)' }}>
                  {t('footer.wiabookApi')}
                </a>
                <a href="https://wiabook.com/pubscript" target="_blank" rel="noopener noreferrer"
                   className="text-[#ff00ff] text-[14px] hover:translate-y-[-2px] transition-all"
                   style={{ textShadow: '0 0 8px rgba(255, 0, 255, 0.5)' }}>
                  {t('footer.pubscript')}
                </a>
                <a href="https://wiabook.com/pubscript-api" target="_blank" rel="noopener noreferrer"
                   className="text-[#ff00ff] text-[14px] hover:translate-y-[-2px] transition-all"
                   style={{ textShadow: '0 0 8px rgba(255, 0, 255, 0.5)' }}>
                  {t('footer.pubscriptApi')}
                </a>
              </div>

              {/* 2행: XR/접근성 도구 (시안) */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-3 pt-4 border-t border-[#00ffff33]">
                <a href="https://wiabook.com/webxr/index.html" target="_blank" rel="noopener noreferrer"
                   className="text-[#00ffff] text-[14px] hover:translate-y-[-2px] transition-all"
                   style={{ textShadow: '0 0 8px rgba(0, 255, 255, 0.5)' }}>
                  {t('footer.webXR')}
                </a>
                <a href="https://a11y.wiabook.com/" target="_blank" rel="noopener noreferrer"
                   className="text-[#00ffff] text-[14px] hover:translate-y-[-2px] transition-all"
                   style={{ textShadow: '0 0 8px rgba(0, 255, 255, 0.5)' }}>
                  {t('footer.a11y')}
                </a>
                <a href="https://wiabook.com/3D_book-detail-page-maker.html" target="_blank" rel="noopener noreferrer"
                   className="text-[#00ffff] text-[14px] hover:translate-y-[-2px] transition-all"
                   style={{ textShadow: '0 0 8px rgba(0, 255, 255, 0.5)' }}>
                  {t('footer.detail3D')}
                </a>
                <a href="https://wiabook.com/wia-epub-bookshelf/" target="_blank" rel="noopener noreferrer"
                   className="text-[#00ffff] text-[14px] hover:translate-y-[-2px] transition-all"
                   style={{ textShadow: '0 0 8px rgba(0, 255, 255, 0.5)' }}>
                  {t('footer.reader')}
                </a>
              </div>

              {/* 3행: 변환기/도구 (시안) */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-3">
                <a href="https://wiabook.com/wia-pdf" target="_blank" rel="noopener noreferrer"
                   className="text-[#00ffff] text-[14px] hover:translate-y-[-2px] transition-all"
                   style={{ textShadow: '0 0 8px rgba(0, 255, 255, 0.5)' }}>
                  {t('footer.pdfConverter')}
                </a>
                <a href="https://wiabook.com/wiabook-cover-calculator.html" target="_blank" rel="noopener noreferrer"
                   className="text-[#00ffff] text-[14px] hover:translate-y-[-2px] transition-all"
                   style={{ textShadow: '0 0 8px rgba(0, 255, 255, 0.5)' }}>
                  {t('footer.bookCover')}
                </a>
                <a href="https://wihp.wiastandards.com/" target="_blank" rel="noopener noreferrer"
                   className="text-[#00ffff] text-[14px] hover:translate-y-[-2px] transition-all"
                   style={{ textShadow: '0 0 8px rgba(0, 255, 255, 0.5)' }}>
                  {t('footer.wihpConverter')}
                </a>
                <a href="https://check.wiasis.com/" target="_blank" rel="noopener noreferrer"
                   className="text-[#00ffff] text-[14px] hover:translate-y-[-2px] transition-all"
                   style={{ textShadow: '0 0 8px rgba(0, 255, 255, 0.5)' }}>
                  {t('footer.plagiarismChecker')}
                </a>
              </div>

              {/* 4행: 정책/기타 (보라) */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-3 pt-4 border-t border-[#8a2be233]">
                <a href="https://wiabook.com/accessibility/" target="_blank" rel="noopener noreferrer"
                   className="text-[#a78bfa] text-[14px] hover:translate-y-[-2px] transition-all">
                  {t('footer.accessibility')}
                </a>
                <a href="https://wiabook.com/contact-us" target="_blank" rel="noopener noreferrer"
                   className="text-[#a78bfa] text-[14px] hover:translate-y-[-2px] transition-all">
                  {t('footer.contact')}
                </a>
                <a href="https://wiabook.com/privacy-policy" target="_blank" rel="noopener noreferrer"
                   className="text-[#a78bfa] text-[14px] hover:translate-y-[-2px] transition-all">
                  {t('footer.privacy')}
                </a>
                <a href="https://wiabook.com/terms-of-service" target="_blank" rel="noopener noreferrer"
                   className="text-[#a78bfa] text-[14px] hover:translate-y-[-2px] transition-all">
                  {t('footer.terms')}
                </a>
              </div>

              {/* 5행: WIA 서비스 1 (보라) */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-3">
                <a href="https://wiabook.com/wia-font/" target="_blank" rel="noopener noreferrer"
                   className="text-[#a78bfa] text-[14px] hover:translate-y-[-2px] transition-all">
                  {t('footer.font')}
                </a>
                <a href="https://wiago.link/" target="_blank" rel="noopener noreferrer"
                   className="text-[#a78bfa] text-[14px] hover:translate-y-[-2px] transition-all">
                  {t('footer.wiaGo')}
                </a>
                <a href="https://wiavideo.com/" target="_blank" rel="noopener noreferrer"
                   className="text-[#a78bfa] text-[14px] hover:translate-y-[-2px] transition-all">
                  {t('footer.wiaVideo')}
                </a>
                <a href="https://wia.tools/" target="_blank" rel="noopener noreferrer"
                   className="text-[#a78bfa] text-[14px] hover:translate-y-[-2px] transition-all">
                  {t('footer.wiaTools')}
                </a>
              </div>

              {/* 6행: WIA 서비스 2 (보라) */}
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-3">
                <a href="https://wia.live/" target="_blank" rel="noopener noreferrer"
                   className="text-[#a78bfa] text-[14px] hover:translate-y-[-2px] transition-all">
                  {t('footer.wiaLive')}
                </a>
                <a href="https://wiabraille.com/" target="_blank" rel="noopener noreferrer"
                   className="text-[#a78bfa] text-[14px] hover:translate-y-[-2px] transition-all">
                  {t('footer.wiaBraille')}
                </a>
                <a href="https://wiatalk.com/" target="_blank" rel="noopener noreferrer"
                   className="text-[#a78bfa] text-[14px] hover:translate-y-[-2px] transition-all">
                  {t('footer.wiaTalk')}
                </a>
                <a href="https://wiastandards.com/" target="_blank" rel="noopener noreferrer"
                   className="text-[#a78bfa] text-[14px] hover:translate-y-[-2px] transition-all">
                  {t('footer.wiaStandards')}
                </a>
              </div>

            </div>
          </div>

          {/* 홀로그램 구분선 */}
          <div
            className="h-px max-w-full mx-auto mb-4 mt-4"
            style={{
              background: 'linear-gradient(90deg, transparent, #ff00ff, #00ffff, #ff00ff, transparent)',
              boxShadow: '0 0 10px rgba(255, 0, 255, 0.3)'
            }}
          />

          {/* 이메일 수집 금지 안내 */}
          <p className="text-center text-[12px] text-[#666688]">
            {t('footer.emailNotice')}
          </p>

          {/* 저작권 */}
          <p className="mt-3 text-center text-[#00ffff] font-semibold tracking-wide text-[14px]"
             style={{ textShadow: '0 0 10px rgba(0, 255, 255, 0.5)' }}>
            © 2013 - {currentYear} {t('footer.publisherName')} (WIA Book) - BENEFIT ALL HUMANITY
          </p>
        </div>

        {/* 네온 글로우 라인 하단 */}
        <div
          className="h-[2px]"
          style={{
            background: 'linear-gradient(90deg, #00ffff, #ff00ff, #00ffff)',
            boxShadow: '0 0 15px #00ffff, 0 0 30px #ff00ff'
          }}
        />
      </footer>
    </>
  );
};

export default Footer;
